/* NIBLaunchDialogRenderer.js */

"use strict";
const ModalUserFeedback = require("@gluenetworks/modal_user_feedback").modalUserFeedback;

class NIBLaunchDialogRenderer {
    constructor(model) {
        this._model = model;
        this._rootElem = document.createElement("nib-launch-dialog-gl");
        this._rootElem.classList.add("modal-confirmation-gl");
        this._rootElem.component = this._model;

        this._progressContainer = document.createElement("div");
        this._progressContainer.classList.add("progress_container");
        this._modalUserFeedback = new ModalUserFeedback();

        this._registerListeners();
    }
    /********************************************/
    /* START PRIVATE COMPONENT RENDERER METHODS */
    /********************************************/
    _registerListeners() {
        this._model.on(
            "UpdateNIBProgress",
            (this._onUpdateNIBProgress = this._onUpdateNIBProgress.bind(this))
        );
        this._progressContainer.addEventListener(
            "mousedown",
            (this._mouseDown = this._mouseDown.bind(this))
        );
        this._progressContainer.addEventListener(
            "mouseup",
            (this._mouseUp = this._mouseUp.bind(this))
        );
    }
    _unregisterListeners() {
        this._model.removeListener("UpdateNIBProgress", this._onUpdateNIBProgress);
        this._progressContainer.removeEventListener("mousedown", this._mouseDown);
        this._progressContainer.removeEventListener("mouseup", this._mouseUp);
    }
    /*******************************************/
    /* END PRIVATE COMPONENT RENDERER METHODS  */
    /* START PUBLIC COMPONENT RENDERER METHODS */
    /*******************************************/
    shutdown() {
        this._unregisterListeners();

        return Promise.resolve()
            .then(() => {
                this._model = undefined;
                this._rootElem.remove();
                this._rootElem = undefined;
            })
            .then(() => {
                this._modalUserFeedback.shutdown();
            });
    }
    /**
     * Stateless method to completely rebuild this component from the _rootElem down.
     * @returns {Promise} An ES6 promise that lets the caller know when the component has finished rendering. If a non
     * Promise is returned the caller will assume the Renderer has completed rendering.
     */
    render() {
        if (!this._rootElem.hasChildNodes()) {
            this._titleElem = document.createElement("h2");

            let containerElem = document.createElement("div");
            containerElem.classList.add(
                "nib-launch-container",
                "modal-confirmation-gl",
                "modal_feedback_container"
            );

            this._rootElem.appendChild(this._modalUserFeedback.renderer.rootElement);
            this._rootElem.appendChild(containerElem);
            containerElem.appendChild(this._titleElem);
            containerElem.appendChild(this._progressContainer);
        }

        return Promise.resolve()
            .then(() => {
                return this._renderTitle();
            })
            .then(() => {
                return this._renderProgress();
            });
    }
    get rootElement() {
        return this.getRootElement();
    }
    getRootElement() {
        return this._rootElem;
    }
    get model() {
        return this.getModel();
    }
    getModel() {
        return this._model;
    }
    /*******************************************/
    /* END COMPONENT RENDERER METHODS */
    /* START PRIVATE RENDER METHODS */
    /*******************************************/
    _renderTitle() {
        this._titleElem.innerText = this._model.title;
    }
    _renderProgress() {}
    /*******************************************/
    /* END PRIVATE RENDER METHODS */
    /* START HANDLER METHODS */
    /*******************************************/
    _onUpdateNIBProgress(progressObj) {
        if (progressObj.lastLogEventInfo) {
            let logEvent = progressObj.lastLogEventInfo;
            let logLine;
            let indent = "";
            if (logEvent.depth) {
                for (let i = 0; i < logEvent.depth; i++) {
                    indent += "&emsp;";
                }
            }
            switch (logEvent.lvl) {
                case "TASK": {
                    if (logEvent.taskDuration) {
                        logLine = indent + "<< " + logEvent.msg;
                    } else {
                        logLine = indent + ">> " + logEvent.msg;
                    }
                    break;
                }
                case "CHECKPOINT": {
                    logLine = indent + "! " + logEvent.msg;
                }
            }
            if (logLine) {
                let msg = document.createElement("p");
                msg.classList.add("log-entry");
                msg.innerHTML = logLine;
                let autoScroll = true;
                let scrollOffset =
                    this._progressContainer.scrollTop + this._progressContainer.offsetHeight;

                if (scrollOffset < this._progressContainer.scrollHeight) {
                    autoScroll = false;
                }
                this._progressContainer.appendChild(msg);

                let scrollPresent = false;
                if (this._progressContainer.scrollHeight > this._progressContainer.offsetHeight) {
                    scrollPresent = true;
                }
                if (scrollPresent && autoScroll) {
                    this._progressContainer.scrollTop = this._progressContainer.scrollHeight;
                }
            }
        }
    }

    _mouseDown() {}
    _mouseUp() {}

    /*******************************************/
    /* END HANDLER METHODS */
    /* START PRIVATE API METHODS */
    /*******************************************/
    _displayLoading() {
        return this._modalUserFeedback.displayLoading();
    }
    _displayError(error) {
        return this._modalUserFeedback.displayError(error);
    }
    /*******************************************/
    /*  END PRIVATE API METHODS */
    /*******************************************/
}
module.exports = NIBLaunchDialogRenderer;
